import { Button } from '@klickly/front-packages';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
    && {
        margin: ${({ $simple }) => ($simple ? '0 auto' : '0')};
    }
`;
